export const environment = {
  production: true,
  development: false,
  test: false,
  authorizeProspectBrands: '[\"VYV\"]',
  product: 'HC',
  brand: 'VYV',
  apiV2RootUrl: 'https://assurance.vyv-conseil.fr/api/',
  baseUrl: 'https://assurance-habitation.vyv-conseil.fr/',
  matomotoKey: 'CHANGEME',
  appInsightsKey: '4b3dcc26-4751-41e6-8b52-328d2684a113',
  assGarantie:
    'https://saboiarpbackofficex5he1.blob.core.windows.net/public/Plaquette_Assurance_Protection_Juridique_Tableau%20des%20garanties.pdf',
  matomoSiteId: 6,
  matomoHostUrl: 'https://stats.groupe-vyv.fr/',
  matomoScriptUrl: 'https://stats.groupe-vyv.fr/js/container_682wvypB.js',
  urlWarranty: {
    assConfort:
      'https://saboiarpbackofficex5he1.blob.core.windows.net/public/VYV_Plaquette_Assurance_Habitation_Confort_Tableau%20des%20garanties.pdf',
    assMetropole:
      'https://saboiarpbackofficex5he1.blob.core.windows.net/public/VYV_Plaquette_Assurance_Habitation_{0}_Tableau%20des%20garanties.pdf',
    assSolidaire:
      'https://saboiarpbackofficex5he1.blob.core.windows.net/public/VYV_Plaquette_Assurance_Habitation_Solidaire_Tableau%20des%20garanties.pdf',
  },
  modeleCourrierResiliation: 'https://saboiarpbackofficex5he1.blob.core.windows.net/public/ModeleCourrier.docx',
  msalConfig: {
    auth: {
      clientId: 'b15a8901-70f9-4814-9c09-82ee5b12d798',
      authority: 'https://login.microsoftonline.com/6f12f368-4cb1-4b07-9574-dd2cdf95d9c1',
      redirectUri: 'https://assurance-habitation.vyv-conseil.fr/',
    },
  },
  apiConfig: {
    scopes: ['api://boiard-prd-back-office/Read.All', 'api://boiard-prd-back-office/Write.All'],
    uri: 'https://assurance.vyv-conseil.fr/api/',
  },
  url_espace_adherent: 'https://assurance.vyv-conseil.fr/mon-espace/',
  googleTagManagerId: 'GTM-M2XCS4XC',
  skeepersTagId: '0ca9a77d9faddd0653a92063233c1633-3961'
};
